import { styled } from 'linaria/react';

export const PriceBlock = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-125);
`;
